// Data tur didefinisikan di FE supaya fleksibel — selector & flag bisa diubah tanpa backend.
// `contentId` = key i18n (src/locales), dibaca via intl.messages (raw, tanpa ICU).
// Module memakai data lokal ini bila nama tur ada di sini; selain itu fallback ke API getTutorial.
const tours = {
  sales: [
    {
      contentId: 'tour.sales.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.sales.step2',
      placement: 'right',
      target: '#kledo-menu-sales',
      isFixed: true,
    },
    {
      contentId: 'tour.sales.step3',
      placement: 'right',
      target: '#kledo-menu-sales',
      isFixed: true,
    },
    {
      contentId: 'tour.sales.step4',
      placement: 'right',
      target: '#kledo-menu-sales',
      isFixed: true,
    },
    {
      contentId: 'tour.sales.step5',
      placement: 'center',
      target: 'body',
      videoId: 'wVXDAghya8I',
      width: 540,
    },
  ],
  quotes: [
    {
      contentId: 'tour.quotes.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.quotes.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.quotes.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.quotes.step4',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.quotes.step5',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.quotes.step6',
      placement: 'top',
      target: '#btn-filter-status-container',
    },
    {
      contentId: 'tour.quotes.step7',
      placement: 'right',
      target: '#btn-filter-25',
    },
    {
      contentId: 'tour.quotes.step8',
      placement: 'bottom',
      target: '#btn-filter-25',
    },
  ],
  purchases: [
    {
      contentId: 'tour.purchases.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.purchases.step2',
      placement: 'right',
      target: '#kledo-menu-purchases',
      isFixed: true,
    },
    {
      contentId: 'tour.purchases.step3',
      placement: 'right',
      target: '#kledo-menu-purchases',
      isFixed: true,
    },
    {
      contentId: 'tour.purchases.step4',
      placement: 'right',
      target: '#kledo-menu-purchases',
      isFixed: true,
    },
    {
      contentId: 'tour.purchases.step5',
      placement: 'center',
      target: 'body',
      videoId: 'Ktzd6uMlR84',
      width: 540,
    },
  ],
  expenses: [
    {
      contentId: 'tour.expenses.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.expenses.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.expenses.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.expenses.step4',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.expenses.step5',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.expenses.step6',
      placement: 'top',
      target: '#btn-filter-status-container',
    },
    {
      contentId: 'tour.expenses.step7',
      placement: 'right',
      target: '#btn-filter-more',
      overlayClickAction: false,
      advanceOnClick: true,
      buttons: ['back', 'close'],
    },
    {
      contentId: 'tour.expenses.step8',
      placement: 'right',
      target: '#btn-filter-recurring',
      buttons: ['close', 'primary'],
      advanceOnClick: true,
      keepDropdownOpen: true,
    },
  ],
  accounts: [
    {
      contentId: 'tour.accounts.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.accounts.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.accounts.step3',
      placement: 'left',
      target: '#btn-manual-journal',
    },
    {
      contentId: 'tour.accounts.step4',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.accounts.step5',
      placement: 'bottom',
      target: '#btn-more',
      overlayClickAction: false,
      advanceOnClick: true,
      buttons: ['back', 'close'],
    },
    {
      contentId: 'tour.accounts.step6',
      placement: 'bottom',
      target: '#btn-conversion-balance',
      advanceOnClick: true,
      keepDropdownOpen: true,
    },
    {
      contentId: 'tour.accounts.step7',
      placement: 'bottom',
      target: '#btn-closing-book',
    },
    {
      contentId: 'tour.accounts.step8',
      placement: 'right',
      target: '.ant-table-cell.ant-table-selection-column .ant-table-selection',
    },
    {
      contentId: 'tour.accounts.step9',
      placement: 'left',
      target: '.header-column-balance',
    },
    {
      contentId: 'tour.accounts.step10',
      placement: 'center',
      target: 'body',
      videoId: 'gupl4YuibB4',
      width: 540,
    },
  ],
  add_contact: [
    {
      contentId: 'tour.add_contact.step1',
      placement: 'bottom',
      target: '#contact-title',
    },
    {
      contentId: 'tour.add_contact.step2',
      placement: 'bottom',
      target: '.form-item-type_id',
    },
    {
      contentId: 'tour.add_contact.step3',
      placement: 'bottom',
      target: '.form-item-name',
    },
    {
      contentId: 'tour.add_contact.step4',
      placement: 'right',
      target: '#more-form',
    },
    {
      contentId: 'tour.add_contact.step5',
      placement: 'bottom',
      target: '[data-tour-id="tax-legal-section"]',
    },
    {
      contentId: 'tour.add_contact.step6',
      placement: 'top',
      target: '.ant-modal-footer #btn-add',
      videoId: 'SIGdCYCVC00',
      width: 540,
    },
  ],
  add_delivery: [
    {
      contentId: 'tour.add_delivery.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_delivery.step2',
      placement: 'bottom',
      target: '.form-item-ref_number',
    },
    {
      contentId: 'tour.add_delivery.step3',
      placement: 'bottom',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_delivery.step4',
      placement: 'bottom',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_delivery.step5',
      placement: 'right',
      target: '#shipping-information',
    },
    {
      contentId: 'tour.add_delivery.step6',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_delivery.step7',
      placement: 'right',
      target: '.message-attachment-container',
    },
    {
      contentId: 'tour.add_delivery.step8',
      placement: 'left',
      target: '.form-item-shipping_cost',
    },
    {
      contentId: 'tour.add_delivery.step9',
      placement: 'left',
      target: '#btn-save',
      videoId: 'rZHBXz9GxIM',
      width: 540,
    },
  ],
  add_expense: [
    {
      contentId: 'tour.add_expense.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_expense.step2',
      placement: 'bottom',
      target: '#suggestion-account-pay_from_finance_account_id',
    },
    {
      contentId: 'tour.add_expense.step3',
      placement: 'bottom',
      target: '#suggestion-contact-contact_id',
    },
    {
      contentId: 'tour.add_expense.step4',
      placement: 'left',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_expense.step5',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_expense.step6',
      placement: 'left',
      target: '#btn-save',
      videoId: '96b2mWznEGs',
      width: 540,
    },
  ],
  add_fixed_asset: [
    {
      contentId: 'tour.add_fixed_asset.step1',
      placement: 'top',
      target: '#fixed-asset-detail',
    },
    {
      contentId: 'tour.add_fixed_asset.step2',
      placement: 'left',
      target: '.form-item-purchase_price',
    },
    {
      contentId: 'tour.add_fixed_asset.step3',
      placement: 'right',
      target: '#suggestion-account-fixed_asset_account_id',
    },
    {
      contentId: 'tour.add_fixed_asset.step4',
      placement: 'left',
      target: '#suggestion-account-credited_account_id',
    },
    {
      contentId: 'tour.add_fixed_asset.step5',
      placement: 'right',
      target: '.form-item-is_depreciation',
      buttons: ['back', 'close'],
    },
    {
      contentId: 'tour.add_fixed_asset.step6',
      placement: 'right',
      target: '#suggestion-account-accumulated_depreciation_account_id',
    },
    {
      contentId: 'tour.add_fixed_asset.step7',
      placement: 'left',
      target: '#suggestion-account-depreciation_expense_account_id',
    },
    {
      contentId: 'tour.add_fixed_asset.step8',
      placement: 'right',
      target: '.form-item-rate',
    },
    {
      contentId: 'tour.add_fixed_asset.step9',
      placement: 'left',
      target: '#btn-save',
      videoId: '67VScNCB5I8',
      width: 540,
    },
  ],
  add_invoice: [
    {
      contentId: 'tour.add_invoice.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_invoice.step2',
      placement: 'bottom',
      target: '#suggestion-contact-contact_id',
    },
    {
      contentId: 'tour.add_invoice.step3',
      placement: 'bottom',
      target: '.form-item-ref_number',
    },
    {
      contentId: 'tour.add_invoice.step4',
      placement: 'bottom',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_invoice.step5',
      placement: 'bottom',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_invoice.step6',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_invoice.step7',
      placement: 'right',
      target: '.message-attachment-container',
    },
    {
      contentId: 'tour.add_invoice.step8',
      placement: 'left',
      target: '#btn-save',
      videoId: '5XytTtjPu3E',
      width: 540,
    },
  ],
  add_manual_journal: [
    {
      contentId: 'tour.add_manual_journal.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_manual_journal.step2',
      placement: 'left',
      target: '.form-item-ref_number',
    },
    {
      contentId: 'tour.add_manual_journal.step3',
      placement: 'bottom',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_manual_journal.step4',
      placement: 'left',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_manual_journal.step5',
      placement: 'top',
      target: '.items-content',
    },
    {
      contentId: 'tour.add_manual_journal.step6',
      placement: 'right',
      target: '.items-container #btn-add',
    },
    {
      contentId: 'tour.add_manual_journal.step7',
      placement: 'left',
      target: '.summary',
    },
    {
      contentId: 'tour.add_manual_journal.step8',
      placement: 'left',
      target: '#btn-save',
      videoId: 'sWuYFsiIai0',
      width: 540,
    },
  ],
  add_product_conversion: [
    {
      contentId: 'tour.add_product_conversion.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_product_conversion.step2',
      placement: 'right',
      target: '.form-item-qty',
    },
    {
      contentId: 'tour.add_product_conversion.step3',
      placement: 'right',
      target: '.form-item-warehouse_id',
    },
    {
      contentId: 'tour.add_product_conversion.step4',
      placement: 'top',
      target: '#product-items-container',
    },
    {
      contentId: 'tour.add_product_conversion.step5',
      placement: 'top',
      target: '#product-cost-container',
    },
    {
      contentId: 'tour.add_product_conversion.step6',
      placement: 'top',
      target: '.summary',
    },
    {
      contentId: 'tour.add_product_conversion.step7',
      placement: 'left',
      target: '#btn-save',
      isFixed: true,
      videoId: '3NdMFRhc2zE',
      width: 540,
    },
  ],
  add_product_manufacture: [
    {
      contentId: 'tour.add_product_manufacture.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_product_manufacture.step2',
      placement: 'right',
      target: '#is-purchase-container',
    },
    {
      contentId: 'tour.add_product_manufacture.step3',
      placement: 'right',
      target: '#is-sell-container',
    },
    {
      contentId: 'tour.add_product_manufacture.step4',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_product_manufacture.step5',
      placement: 'top',
      target: '.bundle-accounts-container',
    },
    {
      contentId: 'tour.add_product_manufacture.step6',
      placement: 'top',
      target: '.summary',
    },
    {
      contentId: 'tour.add_product_manufacture.step7',
      placement: 'left',
      target: '#btn-save',
      isFixed: true,
      videoId: '3NdMFRhc2zE',
      width: 540,
    },
  ],
  add_product_package: [
    {
      contentId: 'tour.add_product_package.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_product_package.step2',
      placement: 'right',
      target: '#is-sell-container',
    },
    {
      contentId: 'tour.add_product_package.step3',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_product_package.step4',
      placement: 'top',
      target: '.summary',
    },
    {
      contentId: 'tour.add_product_package.step5',
      placement: 'left',
      target: '#btn-save',
      isFixed: true,
      videoId: 'o_rVyxBZ7ow',
      width: 540,
    },
  ],
  add_product: [
    {
      contentId: 'tour.add_product.step1',
      placement: 'left',
      target: '.form-item-code',
    },
    {
      contentId: 'tour.add_product.step2',
      placement: 'right',
      target: '.form-item-is_purchase',
    },
    {
      contentId: 'tour.add_product.step3',
      placement: 'right',
      target: '.form-item-is_sell',
    },
    {
      contentId: 'tour.add_product.step4',
      placement: 'right',
      target: '.form-item-is_track',
    },
    {
      contentId: 'tour.add_product.step5',
      placement: 'right',
      target: '#more-action',
    },
    {
      contentId: 'tour.add_product.step6',
      placement: 'top',
      target: '#btn-save',
      isFixed: true,
      videoId: 'cP5m99UhLkM',
      width: 480,
    },
  ],
  add_purchase_invoice: [
    {
      contentId: 'tour.add_purchase_invoice.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_purchase_invoice.step2',
      placement: 'bottom',
      target: '#suggestion-contact-contact_id',
    },
    {
      contentId: 'tour.add_purchase_invoice.step3',
      placement: 'bottom',
      target: '.form-item-ref_number',
    },
    {
      contentId: 'tour.add_purchase_invoice.step4',
      placement: 'bottom',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_purchase_invoice.step5',
      placement: 'bottom',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_purchase_invoice.step6',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_purchase_invoice.step7',
      placement: 'right',
      target: '.message-attachment-container',
    },
    {
      contentId: 'tour.add_purchase_invoice.step8',
      placement: 'left',
      target: '#btn-save',
      videoId: 'Q2MjmBfnt_8',
      width: 540,
    },
  ],
  add_purchase_order: [
    {
      contentId: 'tour.add_purchase_order.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_purchase_order.step2',
      placement: 'bottom',
      target: '#suggestion-contact-contact_id',
    },
    {
      contentId: 'tour.add_purchase_order.step3',
      placement: 'bottom',
      target: '.form-item-ref_number',
    },
    {
      contentId: 'tour.add_purchase_order.step4',
      placement: 'bottom',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_purchase_order.step5',
      placement: 'bottom',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_purchase_order.step6',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_purchase_order.step7',
      placement: 'right',
      target: '.message-attachment-container',
    },
    {
      contentId: 'tour.add_purchase_order.step8',
      placement: 'left',
      target: '#btn-save',
      videoId: '1ee4ImcGvac',
      width: 540,
    },
  ],
  add_quote: [
    {
      contentId: 'tour.add_quote.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_quote.step2',
      placement: 'bottom',
      target: '#suggestion-contact-contact_id',
    },
    {
      contentId: 'tour.add_quote.step3',
      placement: 'bottom',
      target: '.form-item-ref_number',
    },
    {
      contentId: 'tour.add_quote.step4',
      placement: 'bottom',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_quote.step5',
      placement: 'bottom',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_quote.step6',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_quote.step7',
      placement: 'right',
      target: '.message-attachment-container',
    },
    {
      contentId: 'tour.add_quote.step8',
      placement: 'left',
      target: '[data-tour-id="btn-save"]',
    },
  ],
  add_spend_money: [
    {
      contentId: 'tour.add_spend_money.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_spend_money.step2',
      placement: 'bottom',
      target: '#suggestion-contact-contact_id',
    },
    {
      contentId: 'tour.add_spend_money.step3',
      placement: 'top',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_spend_money.step4',
      placement: 'left',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_spend_money.step5',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_spend_money.step6',
      placement: 'left',
      target: '#btn-save',
      videoId: 'zx3ahuqMqVM',
      width: 540,
    },
  ],
  add_receive_money: [
    {
      contentId: 'tour.add_receive_money.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_receive_money.step2',
      placement: 'bottom',
      target: '#suggestion-contact-contact_id',
    },
    {
      contentId: 'tour.add_receive_money.step3',
      placement: 'top',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_receive_money.step4',
      placement: 'left',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_receive_money.step5',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_receive_money.step6',
      placement: 'left',
      target: '#btn-save',
      videoId: 'zx3ahuqMqVM',
      width: 540,
    },
  ],
  add_stockadjustment: [
    {
      contentId: 'tour.add_stockadjustment.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_stockadjustment.step2',
      placement: 'bottom',
      target: '#StockAdjustmentForm_type_id .ant-radio-wrapper:first-child',
    },
    {
      contentId: 'tour.add_stockadjustment.step3',
      placement: 'right',
      target: '#StockAdjustmentForm_type_id .ant-radio-wrapper:nth-child(2)',
    },
    {
      contentId: 'tour.add_stockadjustment.step4',
      placement: 'top',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_stockadjustment.step5',
      placement: 'bottom',
      target: '#suggestion-account-account_id',
    },
    {
      contentId: 'tour.add_stockadjustment.step6',
      placement: 'bottom',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_stockadjustment.step7',
      placement: 'left',
      target: '.header-column-hpp',
    },
    {
      contentId: 'tour.add_stockadjustment.step8',
      placement: 'left',
      target: '#btn-save',
      videoId: 'NMDS6v7zmdA',
      width: 540,
    },
  ],
  add_transfer_money: [
    {
      contentId: 'tour.add_transfer_money.step1',
      placement: 'right',
      target: '#transfer-money-title',
    },
    {
      contentId: 'tour.add_transfer_money.step2',
      placement: 'bottom',
      target: '#suggestion-account-from_bank_account_id',
    },
    {
      contentId: 'tour.add_transfer_money.step3',
      placement: 'bottom',
      target: '#suggestion-account-to_bank_account_id',
    },
    {
      contentId: 'tour.add_transfer_money.step4',
      placement: 'top',
      target: '.form-item-amount',
    },
    {
      contentId: 'tour.add_transfer_money.step5',
      placement: 'top',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_transfer_money.step6',
      placement: 'top',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_transfer_money.step7',
      placement: 'bottom',
      target: '#btn-transfer',
      videoId: 'zx3ahuqMqVM',
      width: 450,
    },
  ],
  add_warehouse_transfer_in: [
    {
      contentId: 'tour.add_warehouse_transfer_in.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_warehouse_transfer_in.step2',
      placement: 'bottom',
      target: '.form-item-from_warehouse_id',
    },
    {
      contentId: 'tour.add_warehouse_transfer_in.step3',
      placement: 'top',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_warehouse_transfer_in.step4',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_warehouse_transfer_in.step5',
      placement: 'left',
      target: '#btn-save',
      videoId: '3cKyrj2W6nQ',
      width: 540,
    },
  ],
  add_warehouse_transfer_out: [
    {
      contentId: 'tour.add_warehouse_transfer_out.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_warehouse_transfer_out.step2',
      placement: 'bottom',
      target: '.form-item-to_warehouse_id',
    },
    {
      contentId: 'tour.add_warehouse_transfer_out.step3',
      placement: 'top',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_warehouse_transfer_out.step4',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_warehouse_transfer_out.step5',
      placement: 'left',
      target: '#btn-save',
      videoId: '3cKyrj2W6nQ',
      width: 540,
    },
  ],
  cash_bank: [
    {
      contentId: 'tour.cash_bank.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.cash_bank.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.cash_bank.step3',
      placement: 'bottom',
      target: '[data-tour-id="banks-0"]',
    },
    {
      contentId: 'tour.cash_bank.step4',
      placement: 'left',
      target: '[data-tour-id="btn-manage-account-0"]',
    },
    {
      contentId: 'tour.cash_bank.step5',
      placement: 'center',
      target: 'body',
      videoId: 'zx3ahuqMqVM',
      width: 540,
    },
  ],
  contacts: [
    {
      contentId: 'tour.contacts.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.contacts.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.contacts.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.contacts.step4',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.contacts.step5',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.contacts.step6',
      placement: 'center',
      target: 'body',
      videoId: 'SIGdCYCVC00',
      width: 540,
    },
  ],
  conversion_balance: [
    {
      contentId: 'tour.conversion_balance.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.conversion_balance.step2',
      placement: 'left',
      target: '#btn-conversion-date',
    },
    {
      contentId: 'tour.conversion_balance.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.conversion_balance.step4',
      placement: 'top',
      target: '.ant-table-thead',
    },
    {
      contentId: 'tour.conversion_balance.step5',
      placement: 'bottom',
      target: '.ant-table-summary',
    },
    {
      contentId: 'tour.conversion_balance.step6',
      placement: 'left',
      target: '#btn-save',
      videoId: '6Inm69FG9UE',
      width: 540,
    },
  ],
  detail_inventory: [
    {
      contentId: 'tour.detail_inventory.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.detail_inventory.step2',
      placement: 'left',
      target: '.dropdown-stockadjusment-container',
    },
    {
      contentId: 'tour.detail_inventory.step3',
      placement: 'bottom',
      target: '.dropdown-warehousetransfer-container',
    },
    {
      contentId: 'tour.detail_inventory.step4',
      placement: '',
      target: '.product-in-warehouse-table',
    },
    {
      contentId: 'tour.detail_inventory.step5',
      placement: 'bottom',
      target: '#btn-show-column',
    },
    {
      contentId: 'tour.detail_inventory.step6',
      placement: 'top',
      target: '.transactions-container',
    },
    {
      contentId: 'tour.detail_inventory.step7',
      placement: 'center',
      target: 'body',
      videoId: 'r_cxaifNiTU',
      width: 540,
    },
  ],
  fixed_assets: [
    {
      contentId: 'tour.fixed_assets.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.fixed_assets.step2',
      placement: 'right',
      target: '#btn-filter-1',
      videoId: 'a0I9UuThTdw',
      width: 540,
    },
    {
      contentId: 'tour.fixed_assets.step3',
      placement: 'top',
      target: '#btn-filter-2',
    },
    {
      contentId: 'tour.fixed_assets.step4',
      placement: 'right',
      target: '#btn-filter-3',
    },
    {
      contentId: 'tour.fixed_assets.step5',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.fixed_assets.step6',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.fixed_assets.step7',
      placement: 'left',
      target: '#btn-run-depreciation',
    },
  ],
  inventory: [
    {
      contentId: 'tour.inventory.step1',
      placement: 'right',
      target: '.header-column-name',
    },
    {
      contentId: 'tour.inventory.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.inventory.step3',
      placement: 'top',
      target: '.header-column-total_qty',
    },
    {
      contentId: 'tour.inventory.step4',
      placement: 'left',
      target: '.header-column-total_value',
    },
    {
      contentId: 'tour.inventory.step5',
      placement: '',
      target: '.ant-table',
      videoId: '2FNqqrE9WZI',
      width: 540,
    },
  ],
  layout_invoice: [
    {
      contentId: 'tour.layout_invoice.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.layout_invoice.step2',
      placement: 'right',
      target: '#btn-upload',
    },
    {
      contentId: 'tour.layout_invoice.step3',
      placement: 'right',
      target: '#form-invoice_lang_product .ant-space .ant-space-item:nth-child(2)',
    },
    {
      contentId: 'tour.layout_invoice.step4',
      placement: 'right',
      target: '.setting-layout-container',
    },
    {
      contentId: 'tour.layout_invoice.step5',
      placement: 'right',
      target: '.setting-template-container',
    },
    {
      contentId: 'tour.layout_invoice.step6',
      placement: 'center',
      target: 'body',
      videoId: 'csfLPCOq8rY',
      width: 540,
    },
  ],
  invoices: [
    {
      contentId: 'tour.invoices.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.invoices.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.invoices.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.invoices.step4',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.invoices.step5',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.invoices.step6',
      placement: 'top',
      target: '#btn-filter-status-container',
    },
    {
      contentId: 'tour.invoices.step7',
      placement: 'right',
      target: '#btn-filter-more',
      overlayClickAction: false,
      advanceOnClick: true,
      buttons: ['back', 'close'],
    },
    {
      contentId: 'tour.invoices.step8',
      placement: 'right',
      target: '#btn-filter-recurring',
      buttons: ['close', 'primary'],
      advanceOnClick: true,
      keepDropdownOpen: true,
    },
  ],
  deliveries: [
    {
      contentId: 'tour.deliveries.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.deliveries.step2',
      placement: 'right',
      target: '#kledo-menu-orders',
      isFixed: true,
    },
    {
      contentId: 'tour.deliveries.step3',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.deliveries.step4',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.deliveries.step5',
      placement: 'bottom',
      target: '#btn-export',
    },
    {
      contentId: 'tour.deliveries.step6',
      placement: 'right',
      target: '#btn-filter-5',
    },
    {
      contentId: 'tour.deliveries.step7',
      placement: 'right',
      target: '#btn-filter-7',
    },
    {
      contentId: 'tour.deliveries.step8',
      placement: '',
      target: '[data-tour-id="table"]',
    },
  ],
  orders: [
    {
      contentId: 'tour.orders.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.orders.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.orders.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.orders.step4',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.orders.step5',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.orders.step6',
      placement: 'top',
      target: '#btn-filter-status-container',
    },
    {
      contentId: 'tour.orders.step7',
      placement: 'right',
      target: '#btn-filter-more',
      overlayClickAction: false,
      advanceOnClick: true,
      buttons: ['back', 'close'],
    },
    {
      contentId: 'tour.orders.step8',
      placement: 'right',
      target: '#btn-filter-recurring',
      buttons: ['close', 'primary'],
      advanceOnClick: true,
      keepDropdownOpen: true,
    },
  ],
  purchase_invoices: [
    {
      contentId: 'tour.purchase_invoices.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.purchase_invoices.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.purchase_invoices.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.purchase_invoices.step4',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.purchase_invoices.step5',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.purchase_invoices.step6',
      placement: 'top',
      target: '#btn-filter-status-container',
    },
    {
      contentId: 'tour.purchase_invoices.step7',
      placement: 'right',
      target: '#btn-filter-more',
      overlayClickAction: false,
      advanceOnClick: true,
      buttons: ['back', 'close'],
    },
    {
      contentId: 'tour.purchase_invoices.step8',
      placement: 'right',
      target: '#btn-filter-recurring',
      buttons: ['close', 'primary'],
      advanceOnClick: true,
      keepDropdownOpen: true,
    },
  ],
  purchase_deliveries: [
    {
      contentId: 'tour.purchase_deliveries.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.purchase_deliveries.step2',
      placement: 'right',
      target: '#kledo-menu-purchase_orders',
      isFixed: true,
    },
    {
      contentId: 'tour.purchase_deliveries.step3',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.purchase_deliveries.step4',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
    {
      contentId: 'tour.purchase_deliveries.step5',
      placement: 'bottom',
      target: '#btn-export',
    },
    {
      contentId: 'tour.purchase_deliveries.step6',
      placement: 'right',
      target: '#btn-filter-5',
    },
    {
      contentId: 'tour.purchase_deliveries.step7',
      placement: 'right',
      target: '#btn-filter-7',
    },
    {
      contentId: 'tour.purchase_deliveries.step8',
      placement: 'top',
      target: '[data-tour-id="table"]',
    },
  ],
  products: [
    {
      contentId: 'tour.products.step1',
      placement: 'left',
      target: '.dropdown-add-product',
    },
    {
      contentId: 'tour.products.step2',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.products.step3',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.products.step4',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
  ],
  cash_bank_transactions: [
    {
      contentId: 'tour.cash_bank_transactions.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.cash_bank_transactions.step2',
      placement: 'left',
      target: '#db-new-transaction',
    },
    {
      contentId: 'tour.cash_bank_transactions.step3',
      placement: 'left',
      target: '#btn-import',
    },
    {
      contentId: 'tour.cash_bank_transactions.step4',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.cash_bank_transactions.step5',
      placement: 'right',
      target: '#btn-transactions',
    },
    {
      contentId: 'tour.cash_bank_transactions.step6',
      placement: 'right',
      target: '#btn-bankstatements',
    },
    {
      contentId: 'tour.cash_bank_transactions.step7',
      placement: 'bottom',
      target: '#btn-reconcile',
    },
    {
      contentId: 'tour.cash_bank_transactions.step8',
      placement: 'left',
      target: '#btn-recurring',
    },
    {
      contentId: 'tour.cash_bank_transactions.step9',
      placement: 'left',
      target: '.dropdown-settings',
    },
  ],
  add_purchase_delivery: [
    {
      contentId: 'tour.add_purchase_delivery.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.add_purchase_delivery.step2',
      placement: 'bottom',
      target: '.form-item-ref_number',
    },
    {
      contentId: 'tour.add_purchase_delivery.step3',
      placement: 'bottom',
      target: '.form-item-memo',
    },
    {
      contentId: 'tour.add_purchase_delivery.step4',
      placement: 'bottom',
      target: '.tag-suggestion-container',
    },
    {
      contentId: 'tour.add_purchase_delivery.step5',
      placement: 'right',
      target: '#shipping-information',
    },
    {
      contentId: 'tour.add_purchase_delivery.step6',
      placement: 'top',
      target: '.items-container',
    },
    {
      contentId: 'tour.add_purchase_delivery.step7',
      placement: 'right',
      target: '.message-attachment-container',
    },
    {
      contentId: 'tour.add_purchase_delivery.step8',
      placement: 'left',
      target: '.form-item-shipping_cost',
    },
    {
      contentId: 'tour.add_purchase_delivery.step9',
      placement: 'left',
      target: '#btn-save',
    },
  ],
  manual_journal: [
    {
      contentId: 'tour.manual_journal.step1',
      placement: 'right',
      target: '.ant-page-header-heading-left',
    },
    {
      contentId: 'tour.manual_journal.step2',
      placement: 'left',
      target: '#btn-add',
    },
    {
      contentId: 'tour.manual_journal.step3',
      placement: 'bottom',
      target: '#btn-import',
    },
    {
      contentId: 'tour.manual_journal.step4',
      placement: 'left',
      target: '#btn-recurring',
    },
    {
      contentId: 'tour.manual_journal.step5',
      placement: 'right',
      target: '#btn-filter',
    },
    {
      contentId: 'tour.manual_journal.step6',
      placement: 'left',
      target: '.ant-input-affix-wrapper',
    },
  ],
}

export default tours
